// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable new-cap, babel/new-cap, default-case */
import { Record } from "immutable"
import moment from "moment"
import { format, addMonths, addDays, isBefore, isAfter } from "date-fns"
import { legacyParse } from "@radek-palisa/date-fns-upgrade/lib/v2"
import * as R from "ramda"

import constants from "../consts/config"
import { DATE_MODES, DATE_FORMAT, DateMode, DATE_FNS_FORMAT } from "../consts/date"
import type { DateTypes } from "./SearchDate/SearchDate"

type Input = {
  mode?: DateMode
  from?: string
  to?: string
  minStayDays?: number
  maxStayDays?: number
  final?: boolean
  isDefault?: boolean
  type?: DateTypes
}

const SearchDateRecord = Record({
  mode: DATE_MODES.SINGLE,
  from: format(new Date(), DATE_FNS_FORMAT),
  to: format(new Date(), DATE_FNS_FORMAT),
  minStayDays: 2,
  maxStayDays: 10,
  final: true,
  isDefault: true,
  type: null,
})

class SearchDate extends SearchDateRecord {
  constructor(raw: Input = {}) {
    const input = { ...raw } as const
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
    switch (input.mode) {
      case DATE_MODES.SINGLE:
        if (input.from) {
          // @ts-expect-error: Flow to TS migration.
          input.to = input.from
        }
        break

      case DATE_MODES.INTERVAL:
        if (input.from === input.to) {
          // @ts-expect-error: Flow to TS migration.
          input.mode = DATE_MODES.SINGLE
        }
        break

      case DATE_MODES.ANYTIME:
        // @ts-expect-error: Flow to TS migration.
        input.from = format(addDays(new Date(), 1), DATE_FNS_FORMAT)
        // @ts-expect-error: Flow to TS migration.
        input.to = format(addMonths(new Date(), Number(constants.maxSearchMonths)), DATE_FNS_FORMAT)
        break

      case undefined:
        // @ts-expect-error: Flow to TS migration.
        input.mode = input.from === input.to ? DATE_MODES.SINGLE : DATE_MODES.INTERVAL
    }

    super(input)
  }

  // utils
  // =====
  includes(date: string): boolean {
    // @ts-expect-error: Flow to TS migration.
    if (this.mode === DATE_MODES.SINGLE || this.mode === DATE_MODES.INTERVAL) {
      // that add/subtract mambo jambo makes the function inclusive
      // moment().isBetween() is exclusive by default
      return moment.utc(date).isBetween(
        // @ts-expect-error: Flow to TS migration.
        moment.utc(this.from).subtract(1, "day"),
        // @ts-expect-error: Flow to TS migration.
        moment.utc(this.to).add(1, "day"),
        "day",
      )
    }

    return false
  }

  isBefore(date: string): boolean {
    // @ts-expect-error: Flow to TS migration.
    if (this.mode === DATE_MODES.SINGLE || this.mode === DATE_MODES.INTERVAL) {
      // @ts-expect-error: Flow to TS migration.
      return isBefore(this.from, legacyParse(date))
    }

    return false
  }

  isAfter(date: string): boolean {
    // @ts-expect-error: Flow to TS migration.
    if (this.mode === DATE_MODES.SINGLE || this.mode === DATE_MODES.INTERVAL) {
      // @ts-expect-error: Flow to TS migration.
      return isAfter(this.to, legacyParse(date))
    }

    return false
  }

  // getters
  // =======
  getId(): string {
    // @ts-expect-error: Flow to TS migration.
    switch (this.mode) {
      case DATE_MODES.TIME_TO_STAY:
        // @ts-expect-error: Flow to TS migration.
        return R.uniq([this.minStayDays, this.maxStayDays]).join("-")

      case DATE_MODES.SINGLE:
      case DATE_MODES.INTERVAL:
        // @ts-expect-error: Flow to TS migration.
        return R.uniq([this.from, this.to]).join("_")

      default:
        // @ts-expect-error: Flow to TS migration.
        return this.mode
    }
  }

  isSingleDate() {
    // @ts-expect-error: Flow to TS migration.
    return this.mode === DATE_MODES.SINGLE
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/member-ordering
  static fromPlainJS(input: Input): SearchDate {
    return new SearchDate(input)
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/member-ordering, @typescript-eslint/no-inferrable-types
  static toIntervalAround(date: SearchDate, dayCount: number = 1) {
    let subtract = dayCount
    const diff = moment(date.get("from"), DATE_FORMAT)
      .subtract(dayCount, "days")
      .diff(moment(), "days")
    if (diff < 0) {
      subtract = 0
    }
    return date
      .set("mode", DATE_MODES.INTERVAL)
      .set(
        "from",
        moment(date.get("from"), DATE_FORMAT).subtract(subtract, "days").format(DATE_FORMAT),
      )
      .set("to", moment(date.get("from"), DATE_FORMAT).add(dayCount, "days").format(DATE_FORMAT))
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/member-ordering, @typescript-eslint/no-inferrable-types
  static toTimeToStayAround(date: SearchDate, min: number = 2, max: number = 4) {
    return date.set("mode", DATE_MODES.TIME_TO_STAY).set("minStayDays", min).set("maxStayDays", max)
  }
}

export default SearchDate
